type ColorScheme = 'dark' | 'light'

const ROW_GAP = 14
const DEVICE_MARKER_SIZE = 40
const ASSOCIATION_MARKER_SIZE = 28
const CONNECTOR_HEIGHT = ROW_GAP * 2 + ASSOCIATION_MARKER_SIZE

export const darkPopoverStyles = (colorScheme: ColorScheme) => {
  const prefix = colorScheme === 'light' ? 'light.' : ''

  return {
    body: {
      // Own opaque background so the canvas can't show through in dark mode.
      bg: `${prefix}bg.card-elevated`,
      display: 'flex',
      flexDirection: 'column' as const,
      p: '16px',
    },
    deviceRow: {
      alignItems: 'center',
      display: 'flex',
      gap: '12px',
      p: '16px',
    },
    deviceName: {
      color: `${prefix}text.primary`,
      textStyle: 'body',
    },
    feedFrame: {
      p: '8px',
    },
    title: {
      color: `${prefix}text.primary`,
      textStyle: 'label',
      whiteSpace: 'pre-line' as const,
    },
    bulletList: {
      color: `${prefix}text.secondary`,
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '4px',
      mt: '4px',
      textStyle: 'caption',
    },
    connectionList: {
      alignItems: 'flex-start',
      display: 'flex',
      flexDirection: 'column' as const,
      gap: `${ROW_GAP}px`,
      position: 'relative' as const,
    },
    associationRow: {
      alignItems: 'center',
      display: 'flex',
      height: `${ASSOCIATION_MARKER_SIZE}px`,
      justifyContent: 'center',
      width: `${DEVICE_MARKER_SIZE}px`,
      zIndex: 1,
    },
    connectionRow: {
      alignItems: 'center',
      display: 'flex',
      gap: '8px',
    },
    connectionName: {
      color: `${prefix}text.primary`,
      textStyle: 'caption',
    },
    connector: {
      borderLeftStyle: 'dashed',
      borderLeftWidth: '1.5px',
      height: `${CONNECTOR_HEIGHT}px`,
      left: `${DEVICE_MARKER_SIZE / 2}px`,
      position: 'absolute' as const,
      top: `${DEVICE_MARKER_SIZE}px`,
    },
  }
}
